import BaseApi from "./BaseApi"
  
const SUBMISSION_ENDPOINT = "/submission"

class SubmissionApi extends BaseApi {

  async getSubmissions(user) {
    try {
      if (user.isTFBAccount) {
        this.setAuthToken(user.userToken)
      }
      
      const endpoint = `${SUBMISSION_ENDPOINT}/ban`
      const response = await this.get(endpoint)
      return response.data
    } catch (error) {
      throw new Error("Unable to retreive submissions")
    }
  }

  async insert(submissionValues) {
    try {
      const response = await this.post(SUBMISSION_ENDPOINT, submissionValues)
      return response.data
    } catch (error) {
      throw new Error("Unable to create submission")
    }
  }

  async update(iSubmission) {
    try {
      const response = await this.put(SUBMISSION_ENDPOINT, iSubmission)
      return response.data
    } catch (error) {
      throw new Error("Unable to update submission")
    }
  }

  async upload(files, iSubmitId) {
    try {
      const data = new FormData()
      files.forEach((file) => data.append("files", file))
      data.append("files", files)

      const endpoint = `${SUBMISSION_ENDPOINT}/${iSubmitId}/upload`
      const response = await this.post(endpoint, data)
      return response.data
    } catch (error) {
      throw new Error("Unable to upload files")
    }
  }

  async finalize(iSubmission) {
    try {
      const endpoint = `${SUBMISSION_ENDPOINT}/${iSubmission.iSubmitId}/finalize`
      const response = await this.post(endpoint, iSubmission)
      return response.data
    } catch (error) {
      throw new Error("Unable to finalize submission")
    }
  }

  async validateIfExists(offerId, carrier, phoneNumber) {
    try {
      const endpoint = `${SUBMISSION_ENDPOINT}/lookupisubmission`
      const data = {
        offerId: offerId,
        carrier: carrier,
        phoneNumber: phoneNumber
      }
      const response = await this.post(endpoint,data)
      return response.data
    } catch (error) {
      throw new Error("Unable to retreive submission")
    }
  }
}

export default new SubmissionApi()
